import { Link } from "@tanstack/react-router";
export function Footer() {
  return (
    <footer className="experience-footer">
      <div className="experience-wrap footer-grid">
        <div>
          <p className="footer-brand">
            Event <span>Sverige</span>
          </p>
          <p>
            En plats att mötas på. Koncept, aktiviteter och stämningsljus för företagsevent och
            mässor.
          </p>
        </div>
        <div>
          <h2>Upplevelser</h2>
          <Link to="/koncept">Våra koncept</Link>
          <Link to="/foretag">Företagsevent</Link>
          <Link to="/massa">Mässor & aktivering</Link>
          <Link to="/forfragan">Planera ert event</Link>
        </div>
        <div>
          <h2>Hitta vidare</h2>
          <Link to="/om-oss">Om oss</Link>
          <Link to="/faq">Vanliga frågor</Link>
          <Link to="/partner">Bli partner</Link>
          <Link to="/sidkarta">Alla sidor & utrustning</Link>
        </div>
        <div>
          <h2>Kontakt</h2>
          <a href="mailto:info@eventsverige.se">info@eventsverige.se</a>
          <a href="tel:+46317975599">031-797 55 99</a>
        </div>
      </div>
      <div className="experience-wrap footer-bottom">
        © {new Date().getFullYear()} Event Sverige · <Link to="/kontakt">Kontakta oss</Link>
      </div>
    </footer>
  );
}
